import { FAMILIES_NOT_REQUIRING_PAYMENT } from '../constants/payment';
import { matchDate } from './';

export default (billing, currentSubscription) => {
  const { fetchFailed: billingError, nextBillingDate } = billing;
  const billingDateToday =
    !FAMILIES_NOT_REQUIRING_PAYMENT.includes(currentSubscription.family) && matchDate(nextBillingDate);
  const { defermentInfo } = currentSubscription;
  const cardSavePermitted = !defermentInfo && !billingDateToday;
  const switchPermitted = cardSavePermitted && !billingError;
  const switchInfo = {
    billingDateToday,
    cardSavePermitted,
    switchPermitted,
  };
  return switchInfo;
};
